import { FormlyFieldConfig } from '@ngx-formly/core';
import { DetailsFormOptions } from './details-form-options.interface';
import { toFormlyOptions } from './details-form-helpers';

/**
 * SECTION 1: GENERAL INFORMATION
 */
export function getGeneralFields(options: DetailsFormOptions): FormlyFieldConfig[] {
	return [
		{
			fieldGroupClassName: 'row',
			fieldGroup: [
				{
					className: 'col-sm-6 col-lg-4',
					key: 'Lead_Source',
					type: 'select',
					props: {
						label: 'Lead Source',
						options: toFormlyOptions(options.leadSources$),
					},
				},
				{
					className: 'col-sm-6 col-lg-4',
					key: 'Deal_Name',
					type: 'input',
					props: {
						label: 'Application Name',
					},
				},
				{
					className: 'col-sm-6 col-lg-4',
					key: 'Opportunity_Type',
					type: 'select',
					props: {
						label: 'Rapid Status',
						options: toFormlyOptions(options.rapidStatuses$),
					},
				},
				{
					className: 'col-sm-6 col-lg-4',
					key: 'Owner',
					type: 'searchable-select',
					props: {
						label: 'Application Owner',
						options: options.users$,
						valueProp: 'zoho_owner_id',
						labelProp: 'full_name',
						searchPlaceholder: 'Search users',
						noEntriesFoundLabel: 'No matching users found',
					},
				},
				{
					className: 'col-sm-6 col-lg-4',
					key: 'Owner1',
					type: 'searchable-select',
					props: {
						label: 'Owner',
						options: options.users$,
						valueProp: 'zoho_owner_id',
						labelProp: 'full_name',
						searchPlaceholder: 'Search users',
						noEntriesFoundLabel: 'No matching users found',
					},
				},
				{
					className: 'col-sm-6 col-lg-4',
					key: 'Loan_Type',
					type: 'select',
					props: {
						label: 'Loan Type',
						options: toFormlyOptions(options.loanTypes$),
					},
				},
				{
					className: 'col-sm-6 col-lg-4',
					key: 'App_Number',
					type: 'input',
					props: {
						label: 'App Number',
						readonly: true,
					},
					expressions: {
						'props.disabled': 'true', // Disables icon and input
					},
				},
				{
					className: 'col-sm-6 col-lg-4',
					key: '_Application_Number',
					type: 'input',
					props: {
						label: 'Application Number',
						readonly: true,
					},
					expressions: {
						'props.disabled': 'true', // Disables icon and input
					},
				},
				{
					className: 'col-sm-6 col-lg-4',
					key: 'AOB_required',
					type: 'select',
					props: {
						label: 'AOB required',
						options: [
							{ value: 'Yes', label: 'Yes' },
							{ value: 'No', label: 'No' },
						],
					},
				},
				{
					className: 'col-sm-6 col-lg-4',
					key: 'AOB_full_name',
					type: 'input',
					props: {
						label: 'AOB full name',
					},
					expressions: {
						hide: (field: FormlyFieldConfig) => field.model?.AOB_required !== 'Yes',
					},
				},
				{
					className: 'col-sm-6 col-lg-4',
					key: '_Refinanced_Amount',
					type: 'currency',
					props: {
						label: 'Refinanced Amount',
						readonly: true,
					},
					expressions: {
						'props.disabled': 'true', // Disables icon and input
					},
				},
				{
					className: 'col-sm-6 col-lg-4',
					key: '_Amount',
					type: 'currency',
					props: {
						label: 'Amount',
						readonly: true,
					},
					expressions: {
						'props.disabled': 'true', // Disables icon and input
					},
				},
				{
					className: 'col-sm-6 col-lg-4',
					key: '_Approved_Amount',
					type: 'currency',
					props: {
						label: 'Approved Amount',
						readonly: true,
					},
					expressions: {
						'props.disabled': 'true', // Disables icon and input
					},
				},
				{
					className: 'col-sm-6 col-lg-4',
					key: '_Banking_method',
					type: 'input',
					props: {
						label: 'Banking method',
						readonly: true,
					},
					expressions: {
						'props.disabled': 'true', // Disables icon and input
					},
				},
				{
					className: 'col-sm-6 col-lg-4',
					key: '_FinalAmount',
					type: 'currency',
					props: {
						label: 'Final Amount',
						readonly: true,
					},
					expressions: {
						'props.disabled': 'true', // Disables icon and input
					},
				},
				{
					className: 'col-sm-6 col-lg-4',
					key: '_Final_Agency_Amount',
					type: 'currency',
					props: {
						label: 'Final Agency Amount',
						readonly: true,
					},
					expressions: {
						'props.disabled': 'true', // Disables icon and input
					},
				},
				{
					className: 'col-sm-6 col-lg-4',
					key: '_API_Created_By',
					type: 'searchable-select',
					props: {
						label: 'API Created By',
						options: options.users$,
						valueProp: 'zoho_owner_id',
						labelProp: 'full_name',
						searchPlaceholder: 'Search users',
						noEntriesFoundLabel: 'No matching users found',
						readonly: true,
					},
					expressions: {
						'props.disabled': 'true', // Disables icon and input
					},
				},
				{
					className: 'col-sm-6 col-lg-4',
					key: '_API_Modified_By',
					type: 'searchable-select',
					props: {
						label: 'API Modified By',
						options: options.users$,
						valueProp: 'zoho_owner_id',
						labelProp: 'full_name',
						searchPlaceholder: 'Search users',
						noEntriesFoundLabel: 'No matching users found',
						readonly: true,
					},
					expressions: {
						'props.disabled': 'true', // Disables icon and input
					},
				},
				{
					className: 'col-sm-6 col-lg-4',
					key: '_Created_By',
					type: 'input',
					props: {
						label: 'Created By',
						readonly: true,
					},
					expressions: {
						'props.disabled': 'true', // Disables icon and input
					},
				},
				{
					className: 'col-sm-6 col-lg-4',
					key: '_Modified_By',
					type: 'searchable-select',
					props: {
						label: 'Modified By',
						options: options.users$,
						valueProp: 'zoho_owner_id',
						labelProp: 'full_name',
						searchPlaceholder: 'Search users',
						noEntriesFoundLabel: 'No matching users found',
						readonly: true,
					},
					expressions: {
						'props.disabled': 'true', // Disables icon and input
					},
				},
				{
					className: 'col-sm-6 col-lg-4',
					key: 'AOB_file',
					type: 'select',
					props: {
						label: 'AOB file has been created?',
						options: [
							{ value: 'Yes', label: 'Yes' },
							{ value: 'No', label: 'No' },
						],
					},
					expressions: {
						'props.disabled': 'true', // Disables icon and input
					},
				},
			],
		},
	];
}